import React from "react";
import ChartWrapper from "../graph/ChartWrapper";
import {
  CardData,
  CategoryDef,
} from "api/interfaces/dashboardInterface.interface";
import { getDashabordOrganizationStatus } from "api/widgetAPI";
import useStatsData from "hook/useStatsData";

export default function SubscriptionStatus(props: CardData) {
  const { statsData, data, legend, interval, setInterval } = useStatsData({
    queryFn: getDashabordOrganizationStatus,
    queryName: "organizationStatus",
    items: props.items as CategoryDef[],
  });
  return (
    <ChartWrapper
      rows={data}
      items={props.items as CategoryDef[]}
      onChangeInterval={setInterval}
      interval={interval}
      legend={legend}
      isLoading={statsData.isLoading}
    />
  );
}
